var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pointer",attrs:{"shift-v":"-1"}},[_c('b-icon',{staticClass:"iconColor1",attrs:{"icon":"chevron-left","font-scale":"1.75"}}),_c('span',{staticClass:"fs-5 iconColor1"},[_c('strong',[_vm._v(_vm._s(_vm.text))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }